import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import { Phone, Loader2 } from "lucide-react";

const PhoneGate = () => {
  const { user, setUser } = useAuth();
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);

  const needsPhone = user && !user.phone && user.role !== "admin";

  useEffect(() => {
    if (needsPhone) setPhone("");
  }, [needsPhone]);

  if (!needsPhone) return null;

  const save = async (e) => {
    e.preventDefault();
    const clean = phone.replace(/\s+/g, "");
    if (clean.length < 7) {
      toast.error("Numero di telefono non valido");
      return;
    }
    setSaving(true);
    try {
      const r = await api.put("/auth/profile", { phone: clean });
      setUser(r.data);
      toast.success("Grazie! Profilo completato.");
    } catch {
      toast.error("Errore nel salvataggio");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="max-w-md" data-testid="phone-gate-dialog" onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()}>
        <DialogHeader>
          <div className="w-12 h-12 rounded-xl bg-sky-50 grid place-items-center mb-3">
            <Phone className="w-5 h-5 text-sky-700" />
          </div>
          <DialogTitle className="font-heading text-2xl text-[#032B44]">
            Completa il tuo profilo
          </DialogTitle>
          <p className="text-sm text-slate-600 mt-1">
            Ci serve un numero di telefono per contattarti al momento della consegna.
          </p>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <label className="block">
            <span className="text-xs tracking-wider uppercase font-bold text-sky-600 block mb-1.5">Numero di telefono *</span>
            <Input
              type="tel"
              autoFocus
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="es. 349 1150597"
              className="h-11"
              data-testid="phone-gate-input"
            />
          </label>
          <Button type="submit" disabled={saving} className="w-full h-11 bg-[#032B44] hover:bg-[#00A3FF] text-white" data-testid="phone-gate-submit">
            {saving ? <><Loader2 className="w-4 h-4 mr-2 animate-spin" /> Salvataggio…</> : "Salva e continua"}
          </Button>
          <p className="text-[11px] text-slate-500 text-center">Useremo il numero solo per coordinare la consegna.</p>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PhoneGate;
